import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, shareReplay } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IPeopleDetails } from '../components/people-picker/people-picker.component';

interface CacheEntry {
  obs$: Observable<IPeopleDetails[]>;
  expiresAt: number;
}

const CACHE_TTL_MS = 2 * 60 * 1000; // 2 minutes

@Injectable({ providedIn: 'root' })
export class PeoplePickerCacheService {
  private cache = new Map<string, CacheEntry>();

  constructor(private http: HttpClient) {}

  search(peoplePickerAddr: string, text: string, xApiKey: string, bearerToken: string): Observable<IPeopleDetails[]> {
    const key = text.toLowerCase();
    const now = Date.now();
    const cached = this.cache.get(key);
    if (cached && cached.expiresAt > now) {
      return cached.obs$;
    }

    const url =
      peoplePickerAddr +
      "peoplebasicinfo?$top=10&$filter=startswith(EnterpriseId,'" +
      text +
      "')";
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('x-api-key', xApiKey)
      .set('authorizationToken', 'Bearer ' + bearerToken);

    const obs$ = this.http.get<{ value: IPeopleDetails[] }>(url, { headers }).pipe(
      map((res: any) => {
        const items: IPeopleDetails[] = Array.isArray(res) ? res : (res?.value ?? []);
        return items.filter((obj) => obj.EmploymentStatusCode === '3');
      }),
      catchError((err) => {
        console.error('PeoplePicker fetch error:', err);
        this.cache.delete(key);
        return of([] as IPeopleDetails[]);
      }),
      shareReplay(1)
    );

    this.cache.set(key, { obs$, expiresAt: now + CACHE_TTL_MS });
    return obs$;
  }
}
